function replaceTBKWithSpan(inputString: string) {
    return inputString.replace(/\b(tbk)\b/gi, (match) => {
        return `<span class="tbk_color_adjusted custom-text-color">${match}</span>`;
    });
}
function replaceWTBKWithSpan(inputString: string) {
    return inputString.replace(/\b(wab)\b/gi, (match) => {
        return `<span class="tbk_color_adjusted custom-text-color">${match}</span>`;
    });
}
function replaceUSDTWithSpan(inputString: string) {
    return inputString.replace(/\b(usdt)\b/gi, (match) => {
        return `<span class="tbk_color_adjusted custom-text-color">${match}</span>`;
    });
}

const adjustTBKColor = () => {
    let tbkContents: any = document?.querySelector("body")?.querySelectorAll("*");
    if (!tbkContents) return;
    tbkContents = Array.from(tbkContents);
    const length = tbkContents?.length ?? 0;
    for (let i = 0; i < length; i++) {
        const e = tbkContents[i];
        if (
            typeof e.className != "string" ||
            e.innerHTML?.toLowerCase()?.includes("</") ||
            e.innerHTML?.toLowerCase()?.includes("<")
        )
            continue;
        if (
            e.innerHTML?.toLowerCase()?.includes("tbk") &&
            !e.className?.includes("tbk_color_adjusted") &&
            !e.className?.includes("not_apply_adjust_color_tbk")
        ) {
            e.innerHTML = replaceTBKWithSpan(e.innerHTML);
        }
        if (
            e.innerHTML?.toLowerCase()?.includes("wab") &&
            !e.className?.includes("tbk_color_adjusted") &&
            !e.className?.includes("not_apply_adjust_color_tbk")
        ) {
            e.innerHTML = replaceWTBKWithSpan(e.innerHTML);
        }
        if (
            e.innerHTML?.toLowerCase()?.includes("usdt") &&
            !e.className?.includes("tbk_color_adjusted") &&
            !e.className?.includes("not_apply_adjust_color_tbk")
        ) {
            e.innerHTML = replaceUSDTWithSpan(e.innerHTML);
        }
    }
};

export default adjustTBKColor;
